// extracted by mini-css-extract-plugin
export default {"wrapper":"Environments_wrapper__E3tIz"};